import React, { useEffect, useState,useRef }  from 'react'
import PngImg from '../../images/sample.png'
import { IoMdClose } from 'react-icons/io'
import { FaFileUpload } from 'react-icons/fa'
import * as pdfjs from 'pdfjs-dist'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.mjs'
pdfjs.GlobalWorkerOptions.workerSrc = 'pdfjs-dist/build/pdf.worker.mjs'

export default function UploadPdfDragAndDropShowPng() {
  const ref = useRef()
  const [files, setFiles] = useState([])
  const onChange2Upload = (e) => {
    console.log('clicked uplaod manually')
    const y = e.target.files
    if (y && y.length > 0) {
      const z = Array.from(y)
      setFiles((x) => [...x, ...z])
    }
  }
  const onDrop2Upload = (e) => {
    e.preventDefault()
    const y = e.dataTransfer.files
    if (y.length > 0) {
      const z = Array.from(y)
      setFiles((x) => [...x, ...z])
    }
  }
  const onClick2RemoveUploadedFile = (y) => {
    console.log('remove y', y)
    setFiles((x) => x.filter((i, a) => a !== y))
  }
  // useEffect(() => {
  //   onFilesSelected(files)
  // }, [files, onFilesSelected])

  // const [file, setFile] = useState(PngImg) //src
  // const [fileSize, setFileSize] = useState()
  // const [fileType, setFileType] = useState()
  // const [uploaded, setUploaded] = useState(false)
  // const getBase64 = x1 => {
  //   return new Promise(x2 => {
  //     let reader = new FileReader()
  //     reader.readAsDataURL(x1)
  //     reader.onload = () => {x2(reader.result)}
  //   })
  // }
  // const onChange2fileUpload = e => {
  //   setFileSize(e.target.files[0].size)
  //   setFileType(e.target.files[0].type)
  //   setUploaded(!uploaded)
  //   getBase64(e.target.files[0]).then(x => {
  //       (pdfjs.getDocument({data: atob(x.replace(/.*base64,/, ''))})).promise.then(function(pdf) {
  //         var pageNumber = 1
  //         pdf.getPage(pageNumber).then(function(page) {
  //           const randomNumber = Math.floor(Math.random() * 10000)
  //           var viewport = page.getViewport({scale: 1})
  //           var canvas = document.createElement('canvas')
  //           var context = canvas.getContext('2d')
  //           canvas.id = randomNumber
  //           canvas.height = 980
  //           canvas.width = 690
  //           canvas.style.display = 'inherit'
  //           var body = document.getElementsByTagName('body')[0]
  //           body.appendChild(canvas)
  //           var renderContext = {
  //             canvasContext: context,
  //             viewport: viewport
  //           }
  //           var applyCanvas = page.render(renderContext)
  //           applyCanvas.promise.then(function () {
  //             var x2 = document.getElementById(randomNumber)
  //             setFile(x2.toDataURL()) 
  //             x2.style.display='none'
  //           })
  //         })
  //       }, function (err) {
  //         console.error(err)
  //       })
  //     })
  //     .catch(err => {
  //       console.log(err)
  //     })
  // }
  // const onClick2fileRemove = (e) => {
  //   e.preventDefault()
  //   ref.current.value = ''
  //   setFile(PngImg)
  //   setUploaded(!uploaded)
  // }
  
    return (
      <>
      <div
        onDrop={onDrop2Upload}
        onDragOver={(e) => e.preventDefault()}
      ><label htmlFor='upload'>
        <>
          <div className='primary-upload'>
          <div className='flex justify-center'><FaFileUpload/></div>
          Drag and drop file at here.
          <input
            type='file'
            hidden
            id='upload'
            onChange={onChange2Upload}
            accept='.pdf,.docx,.pptx,.txt,.xlsx'
            multiple
          />
          {files.length > 0 && (
            <>
                {files.map((x, i) => (<div className='primary-upload-item flex justify-between' key={i}>{x.name}<IoMdClose onClick={() => onClick2RemoveUploadedFile(i)} /></div>))}
            </>
          )}
          </div>
        </>
     </label> </div>
      {/* <div className='upload-container'>
      <div className='text-left'>
      <input 
        type='file' 
        accept='application/pdf'
        onChange={onChange2fileUpload}
        ref={ref}
      />{uploaded?<button className='plane-btn remove-file' onClick={onClick2fileRemove}>x</button>:''}<br/>
        {uploaded? <>{fileType === 'application/pdf'? <div className='success-msg'>✓ pdf file only</div>:<div className='error-msg'>pdf file only</div>}</>
        :<div className='before-check-msg'>✓ pdf file only</div>}
        {uploaded? <>{fileSize < 10485760? <div className='success-msg'>✓ max 10MB</div>:<div className='error-msg'>x  max 10MB({((fileSize-10485760)/ (1024 * 1024)).toFixed(0)}MB exceeded)</div>}</>:<div className='before-check-msg'>✓ max 10MB</div>}
      </div>
      <div className='flex'>
        <div>
        <div className='flex'>
        <img src={process.env.NODE_ENV === 'production'?`${process.env.REACT_APP_URL}${file.slice(1)}`:file} className='sample-img'/>
        </div>
        </div>
      </div>
      </div> */}
      </>
    )
  }